module.exports = __webpack_public_path__ + "static/media/iq.3d18ebeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/iq.png
// module id = 1885
// module chunks = 0